module.exports = __webpack_public_path__ + "img/logo_negro_1.332c9638.png";